import script from "./NavMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavMenu.vue?vue&type=script&lang=ts&setup=true"

import "./NavMenu.vue?vue&type=style&index=0&id=6ec5641b&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ec5641b"]])

export default __exports__